import api from "@/libs/api";
import store from "@/store";

const initState = {
  funnel_data: "",
  funnel_book_show: "",
  mylist: [],
  selflist: [],
  chartLocal:0,
  chartStatus:{
    is:true,
    id:0,
    status:0,
  },
  chartGroup:[],
  chartAllGroup:[],
};

const funnel = {
  state: initState,
  mutations: {
    SET_FUNNEL_DATA(state, proload) {
      state.funnel_data = proload
    },
    SET_FUNNEL_URL(state, url) {
      state.funnel_book_show = url
    },
    SET_MYLIST(state, url) {
      state.mylist = url
    },
    SET_SELF_LIST(state, url) {
      state.selflist = url
    },
    SET_LOCAL(state,pay){
      state.chartLocal = pay
    },
    SET_STATUS(state,pay){
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>")
      state.chartStatus = pay
    },
    SET_CHARTGROUP(state,pay){
      state.chartGroup=pay.chartGroup
      state.chartAllGroup=pay.chartAllGroup
    }
  },
  getters: {},
  actions: {},
};

export default funnel;



// WEBPACK FOOTER //
// ./src/store/modules/funnel.js